"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getNumberFromUnknown_1 = __importDefault(require("../../shared/getNumberFromUnknown"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const buildCallableOpenGeoMap = (args) => async ({ functionId, callbacks, executeProcesses, entryVars: { latitude, longitude, }, }) => {
    const executeError = (message) => {
        executeProcesses(functionId, callbacks.onError, message);
    };
    let lat;
    try {
        lat = (0, getNumberFromUnknown_1.default)(latitude);
    }
    catch (_a) {
        executeError('Latitude value should be a number or a string');
        return;
    }
    let long;
    try {
        long = (0, getNumberFromUnknown_1.default)(longitude);
    }
    catch (_b) {
        executeError('Longitude value should be a number or a string');
        return;
    }
    await args.openGeoMap(lat, long).then(() => {
        executeProcesses(functionId, callbacks.success, {
            latitude: `${lat}`,
            longitude: `${long}`,
        });
    }).catch((error) => {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        executeError(`${errorMessage}`);
    });
};
exports.default = buildCallableOpenGeoMap;
